<template>
  <div>
    <a-modal
      :visible="visible"
      :closable="false"
      :footer="null"
      :centered="true"
      dialogClass="logout-dialog"
    >
      <div class="logout-content-wrapper">
        <img
          src="~@/assets/images/common/logout-warning-icon.svg"
          alt=""
          class="logout-wraning-icon"
        >
        <div class="logout-wraing">
          <p class="logout-wraning-title">会话超时提示</p>
          <p class="logout-warning-tip">由于您较长时间未进行任何操作，系统自动签退，如需继续使用，请重新登录。</p>
        </div>
      </div>
      <div class="logout-btn-wrapper">
        <a-button
          type="primary"
          class="logout-btn-ok"
          @click="handleOk"
        >我知道了</a-button>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { removeStore, getStore } from '@/utils/storage'
import { logout } from '@/api/personal.js'
export default {
  data () {
    return {
      visible: false
    }
  },
  methods: {
    handleShowDialog () {
      console.log("1");
      logout({
        outCode: 1
      }).then(() => {
      })
      this.visible = true
    },
    clearStorage () {
      removeStore('privateAccessToken')
      removeStore('userInfo')
      removeStore('industryId')
      removeStore('menu')
      removeStore('projectInfo')
      removeStore('kbBaseUrl')
      removeStore('allMenuCode')
      removeStore('curEnterpriseInfo')
      removeStore('allPermCode')
      removeStore('appId')
      removeStore('industryId')
    },
    handleOk () {
      sessionStorage.removeItem('subCode')
      // localStorage.clear()
      this.clearStorage()
      this.visible = false
      let getLinkCode = getStore('setLinkCode')
      if (getLinkCode && getLinkCode !== 'undefined') {
        window.location.replace(`${window.location.origin}/auth/login/${getLinkCode}`)
      } else {
        window.location.reload()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.logout-content-wrapper {
  display: flex;
  align-items: flex-start;
  .logout-wraing {
    margin-left: 17px;
    &-title {
      font-weight: 500;
      font-size: 16px;
      color: #262626;
      margin-bottom: 10px;
    }
    &-tip {
      color: #8c8c8c;
      font-size: 14px;
      line-height: 22px;
    }
  }
}
</style>